document.querySelectorAll('.testimonial-section').forEach(function (section) {
  var track = section.querySelector('[data-testimonial-track]');
  if (!track) return;

  var slides = Array.prototype.slice.call(track.querySelectorAll('[data-testimonial-slide]'));
  if (slides.length < 2) return;

  var current = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
  if (current < 0) current = 0;

  function show(index) {
    slides[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
  }

  section.querySelectorAll('[data-testimonial-prev]').forEach(function (btn) {
    btn.addEventListener('click', function () { show(current - 1); });
  });

  section.querySelectorAll('[data-testimonial-next]').forEach(function (btn) {
    btn.addEventListener('click', function () { show(current + 1); });
  });
});
